import { IS_NEW_BACKEND_API } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSETS_COUNT } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { AssetStatusOriginal } from './types'

export type AssetFilters = {
  allAssets?: boolean
  assetOwnership?: 'LEASED' | 'OWNED'
  assetStatus?: AssetStatusOriginal
  company?: number
  leaseReturn?: number
  notConnected?: boolean
  activeEndOfLease?: boolean
  isNearLeaseEnd?: boolean
}

export const buildAssetFilterParams = (filters: AssetFilters): URLSearchParams => {
  const searchParams = new URLSearchParams()
  if (filters.assetOwnership) searchParams.append('assetOwnership', filters.assetOwnership)
  if (filters.assetStatus) searchParams.append('assetStatus', filters.assetStatus)
  if (filters.leaseReturn) searchParams.append('leaseReturn', String(filters.leaseReturn))
  if (filters.allAssets) searchParams.append('all', 'true')
  if (filters.company) searchParams.append('company', String(filters.company))
  if (filters.notConnected) searchParams.append('notConnected', 'true')
  if (filters.activeEndOfLease) searchParams.append('activeEndOfLease', 'true')
  if (filters.isNearLeaseEnd) searchParams.append('isNearLeaseEnd', 'true')
  return searchParams
}

export async function getAssetCount(filters: AssetFilters = {}) {
  const searchParams = buildAssetFilterParams(filters)
  const query = searchParams.toString()
  const path = query ? `${API_ROUTE_ADMIN_ASSETS_COUNT}?${query}` : API_ROUTE_ADMIN_ASSETS_COUNT

  return get<number>(path, IS_NEW_BACKEND_API)
}
